<template>
    <div>
        <terms-cuiqiu v-if="project === 'cuiqiu'" />
        <terms-getmx v-if="project === 'getmx'" />
        <terms-pinmx v-if="project === 'pinmx'" />
    </div>
</template>

<script>
import termsCuiqiu from '@/components/terms/cuiqiu.vue'
import termsGetmx from '@/components/terms/getmx.vue'
import termsPinmx from '@/components/terms/pinmx.vue'
export default {
    name: 'Terms',
    components: {
        termsCuiqiu,
        termsGetmx,
        termsPinmx
    },
    data () {
        return {
            project: process.env.VUE_APP_PROJECT
        }
    }
}
</script>

<style scoped>
.terms-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.terms-title {
  text-align: center;
  margin-bottom: 30px;
}

.terms-content {
  line-height: 1.6;
}

.terms-date {
  text-align: right;
  margin-bottom: 20px;
}

.terms-section {
  margin-bottom: 30px;
}

.terms-section h2 {
  margin-bottom: 15px;
  font-size: 1.2em;
}

.terms-section ul {
  padding-left: 20px;
}

.terms-section li {
  margin-bottom: 10px;
}
</style>
